import styles from "./printDomainScreenBackground.module.scss";

/** Домен print: #2e2b46 → #5d5084 (ниже по тону hub, низ чуть глубже лавандового эталона) */
export function PrintDomainScreenBackground() {
  return <div className={styles.root} aria-hidden />;
}
